<template>
    <article class="m-eventlistingitem">
        <!--Remove Item for Dashboard
        <div class="e-remove">&times;</div>
        -->
        <div class="e-text result-card__inner flow">
            <div class="result-card__header">
                <h3 class="result-card__title">
                    <a :href="resultItem.Link.Url">
                        {{resultItem.Heading}}
                    </a>
                </h3>
                <span class="visually-hidden">Event</span>
            </div>
            <result-tags :tag-parents="resultItem.TagParents"></result-tags>

            <div class="result-card__content flow max-width-s">
                <p :title="resultItem.Summary">
                    {{truncate(resultItem.Summary)}}
                </p>
            </div>
            <div class="result-card__footer">
                <a :href="resultItem.Link.Url" class="btn">
                    Find out more
                    <span class="visually-hidden"> about {{resultItem.Heading}}</span>
                </a>
                <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
            </div>
        </div>
        <div class="e-details">
            <time :datetime="resultItem.Date.DateTime" class="text-scale-medium">{{eventDateString(resultItem.Content)}}</time>
            <p>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         viewBox="0 0 86.5 140">
                        <defs>
                            <radialGradient id="radial-gradient" cx="43.25" cy="128.15" r="41.13"
                                            gradientTransform="translate(0 91.25) scale(1 0.29)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-opacity="0.5" />
                                <stop offset="1" stop-opacity="0" />
                            </radialGradient>
                        </defs>
                        <title>Asset 1</title>
                        <g id="Layer_2" data-name="Layer 2">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <ellipse class="cls-1" cx="43.25" cy="128.15" rx="41.13" ry="11.85" />
                                <path class="cls-2"
                                      d="M73.51,12A40.86,40.86,0,0,0,43.25,0,40.83,40.83,0,0,0,13,12S0,25.87,0,40.84C0,56.08,4.26,62.16,16.65,85.91a320.68,320.68,0,0,0,26.6,42.24,320.68,320.68,0,0,0,26.6-42.24C82.24,62.16,86.5,56.08,86.5,40.84,86.5,25.87,73.51,12,73.51,12ZM43.25,68.91A28.22,28.22,0,1,1,71.47,40.69,28.23,28.23,0,0,1,43.25,68.91Z" />
                                <path class="cls-3"
                                      d="M73.51,12A40.86,40.86,0,0,0,43.25,0V12.47a28.22,28.22,0,0,1,0,56.44v59.24a320.68,320.68,0,0,0,26.6-42.24C82.24,62.16,86.5,56.08,86.5,40.84,86.5,25.87,73.51,12,73.51,12Z" />
                                <circle class="cls-4" cx="43.25" cy="40.69" r="28.22" />
                            </g>
                        </g>
                    </svg>
                </span>
                {{locationString(resultItem.Content)}}
                <br />
                {{eventTimeString(resultItem.Content)}}
            </p>
        </div>
    </article>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import { globalMixin } from '@/mixins/globalMixin.js'
    import ResultTags from '@/components/SiteSearch/result-tags'
    import { differenceInDays, differenceInHours, format } from '@/utils/date.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ResultTags
        },

        computed: {
            isLoggedIn: function () {
                return isLoggedIn
            }
        },

        methods: {
            eventDateString: function (eventDetails) {
                const endDate = new Date(eventDetails.EventEndDatetime)
                const startDate = new Date(eventDetails.EventStartDatetime)

                const daysBetween = differenceInDays(startDate, endDate)

                if (daysBetween !== 0) {
                    return (
                        format(startDate, Globals.dateFormatUi) +
                        ' - ' +
                        format(endDate, Globals.dateFormatUi)
                    )
                } else {
                    return format(startDate, Globals.dateFormatUi)
                }
            },

            eventTimeString: function (eventDetails) {
                const endDate = new Date(eventDetails.EventEndDatetime)                
                const startDate = new Date(eventDetails.EventStartDatetime)

                const hoursBetween = differenceInHours(startDate, endDate)

                const startTime = eventDetails.EventStartDatetime.split('T')[1].split('.')[0].slice(0, 5)

                if (hoursBetween !== 0) {                   
                    var endTime = eventDetails.EventEndDatetime.split('T')[1].split('.')[0].slice(0, 5)
                    return (
                        startTime.toLowerCase() +
                        '-' +
                        endTime.toLowerCase()
                    )
                } else {
                    return startTime.toLowerCase()
                }
            },

            locationString: function (eventDetails) {
                if (eventDetails.EventVenue) {
                    let location = eventDetails.EventVenue.VenueName

                    if (
                        eventDetails.EventVenue.VenueAddress &&
                        eventDetails.EventVenue.VenueAddress.City
                    ) {
                        location = location + ', ' + eventDetails.EventVenue.VenueAddress.City
                    }

                    return location
                }
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            view: {
                type: String
            }
        }
    }
</script>

<style>
    .cls-1 {
        fill: url(#radial-gradient);
    }

    .cls-2 {
        fill: #78be20;
    }

    .cls-3 {
        fill: #3c864d;
        opacity: 0.3;
    }

    .cls-4 {
        fill: #fff;
    }
</style>
